<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    :create-default-data="createDefaultData"
    max-width="800px"
    :save-menu-list="[]"
    @closed="$emit('closed')"
  >
    <template #header>
      <b>Редактировать участника</b>
    </template>

    <template #title-text>
      <div class="body-2">
        Любые изменения будут сохранены автоматически
      </div>
    </template>

    <template #default>
      <PublicationsParticipantsUsersTable
        :value="users"
        :actions="actions"
        :loading="isLoading"
        type-table="users"
        type-autocomplete="users"
        name="users"
        return-object
        @action:append="onAppend"
        @action:delete="onRemove"
      />
    </template>

    <template #footer>
      <v-spacer />
      <v-btn
        dense
        depressed
        @click.stop="close"
        v-text="'Закрыть'"
      />
    </template>
  </BModalForm>
</template>

<script>
import BModalForm from '@/components/modals/BModalForm.vue'
import PublicationsParticipantsUsersTable from '@/components/common/BTable/BTableWithAutocompleteAsync.vue'
import { ParticipantsApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'
import { unionBy } from 'lodash'
import { publicationsMapper as StoreMapper } from '@/views/Publications/store'
import { DELETE } from '@/helpers/enums/table-actions'
import { createModalRemove } from '@/helpers/createModalRemove'

const createDefaultData = () => ({
})

export const TABLE_ACTIONS = Object.freeze([
  DELETE,
])


export default {
  name: 'PublicationsParticipantModal',
  components: {
    BModalForm,
    PublicationsParticipantsUsersTable,
  },
  inheritAttrs: false,
  props: {
    participant_id: {
      type: [String, Number],
      required: true,
    },

  },
  data: () => ({
    isLoading: false,
    createDefaultData,
    users: [],
    actions: TABLE_ACTIONS,
  }),
  computed: {
  },
  created() {
    const api = new ParticipantsApi()
    this.adapter = new Adapter(api)

    this.getUsers()
  },
  methods: {
    ...StoreMapper.mapMutations(['onParticipantUsersCountChanged']),
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    async getUsers() {
      this.isLoading = true
      try {
        const data = await this.adapter.api.getUsers(this.participant_id)
        this.users = data.data
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoading = false
    },
    async onAppend(data) {
      this.isLoading = true
      try {
        await this.adapter.api.addUser(this.participant_id, { user_id: data.id })

        this.users = unionBy(this.users, [data], 'id')

        this.update()
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
      }
    },
    async onRemove(data, callback) {
      const propsData = {
        titleText: 'Удаление участника',
        mainText: `Вы действительно хотите удалить участника "${data.full_name || data.username}"?`,
        errorText: 'Ошибка удаления участника',
        disableSuccessNotification: true,
        action: async () => {
          const unwatch = callback?.()

          this.isLoading = true
          try {
            await this.adapter.api.removeUser(this.participant_id, { user_id: data.id })

            const value = this.users.slice()
            const index = value.findIndex(({ id }) => id === data.id)
            if (index >= 0) {
              value.splice(index, 1)
              this.users = value
            }

            this.update()
          } catch (e) {
            this.$notice.errors(e)
            throw e
          } finally {
            this.isLoading = false
            unwatch?.()
          }
        },
      }

      const modal = await createModalRemove(this, propsData)
      await modal.open()
    },
    update() {
      this.onParticipantUsersCountChanged({
        payload: this.participant_id, count: this.users.length,
      })
    },
  },
}
</script>
